/**
 * Assignments Tab Component
 * Patient assignment management for Volunteer Management
 */

import React from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Plus } from "lucide-react";

const AssignmentsTab = ({
  isDark,
  assignments,
  setAssignmentDialog
}) => {
  return (
    <Card className={isDark ? "bg-slate-900 border-slate-800" : "bg-white"}>
      <CardHeader className="flex flex-row items-center justify-between">
        <div>
          <CardTitle className="text-lg">Patient Assignments</CardTitle>
          <CardDescription>
            Volunteer-patient assignment management
          </CardDescription>
        </div>
        <Button 
          className="bg-teal-600 hover:bg-teal-700"
          onClick={() => setAssignmentDialog(true)}
          data-testid="new-assignment-btn"
        >
          <Plus className="w-4 h-4 mr-2" />
          New Assignment
        </Button>
      </CardHeader>
      <CardContent className="p-0">
        <Table>
          <TableHeader>
            <TableRow className={isDark ? "border-slate-800" : ""}>
              <TableHead>Volunteer</TableHead>
              <TableHead>Patient</TableHead>
              <TableHead>Location</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Visits</TableHead>
              <TableHead>Schedule</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {assignments.map((assignment) => (
              <TableRow key={assignment.id} className={isDark ? "border-slate-800" : ""} data-testid={`assignment-row-${assignment.id}`}>
                <TableCell className="font-medium">{assignment.volunteer_name}</TableCell>
                <TableCell>{assignment.patient_name}</TableCell>
                <TableCell>{assignment.location || "Home"}</TableCell>
                <TableCell>
                  <Badge className={assignment.status === "active" ? "bg-green-500/20 text-green-400" : "bg-gray-500/20 text-gray-400"}>
                    {assignment.status}
                  </Badge>
                </TableCell>
                <TableCell>{assignment.visit_count || 0}</TableCell>
                <TableCell>{assignment.schedule || "Weekly"}</TableCell>
              </TableRow>
            ))}
            {assignments.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} className="text-center py-8">
                  <p className={isDark ? "text-gray-500" : "text-gray-400"}>
                    No assignments found
                  </p>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default AssignmentsTab;
